import { STOP_CARD, STOP_CARD_ERROR_MESSAGE, STOP_CARD_CLEAR } from '../action/card/stopCard'

const initialState = {
  errorMsg : '',
  stopResult: false
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case STOP_CARD_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: 'An error occurred'
      }
    case `${STOP_CARD}_FULFILLED`:
      if (payload.resultCode === "0") {
        return {
          ...state,
          stopResult: payload.resultText
        }
      } else {
        return {
          ...state,
          errorMsg: payload.resultText
        }
      }
    case `${STOP_CARD}_PENDING`:
      return {
        ...state,
        errorMsg: ''
      }
    case `${STOP_CARD}_REJECTED`:
      return {
        ...state,
        errorMsg: 'Cannot connect to server'
      }
    case STOP_CARD_CLEAR:
      return {
        initialState
      }
    default:
      return state
  }
}
